import {
  CHECK_AUTH,
  CHECK_AUTH_SUCCESS,
  CHECK_AUTH_FAIL,
  CHECK_AUTH_ABORTED,

  REQUEST_STORAGE_COOKIE,
  REQUEST_STORAGE_COOKIE_SUCCESS,
  REQUEST_STORAGE_COOKIE_FAIL,

  SET_REFERRAL,
  SET_REFERRAL_SUCCESS,
  SET_REFERRAL_FAIL,

  LOAD_USER_BALANCE,
  LOAD_USER_BALANCE_SUCCESS,
  LOAD_USER_BALANCE_FAIL,

  SET_CLICK_ID,
  SET_CLICK_ID_SUCCESS,
  SET_CLICK_ID_FAIL,

  SET_NEED_SADUKA_AUTH_UPDATE,
  SET_API_HEADERS,

} from '../actions/auth';

import {
  GET_LAYOUT_DATA_SUCCESS
} from '../actions/menu';

export const USER_ROLE_CODE_MANAGER    = 'M';
export const USER_ROLE_CODE_ADVERTISER = 'A';
export const USER_ROLE_CODE_WEBMASTER  = 'W';
export const USER_ROLE_CODE_ADVMADNET  = 'N';

export const PROJECT_ID_BRAZIL = 43;

const initialState = {
  user: null,
  checkingAuth: false,
  isAuthChecked: false,
  isLoggedIn: false,
  isStorageCookieOk: false,
  isStorageCookieRequesting: false,
  isStorageCookieChecked: false,
  referralUid: null,
  referralUidSetting: false,
  referralUidSet: true,
  clickId: null,
  clickIdReferral: null,
  clickIdEnot: null,
  clickIdSetting: false,
  clickIdSet: true,
  registerAdvertiserForm: {
    first_name: '',
    last_name: '',
    company: '',
    phone: '',
    email: '',
    URL: '',
    industry: '',
    country: '',
    comment: '',
  },
  needSadukaAuthUpdate: null,
  creditsUrl: '',
  balance: {},
  apiHeaders: {},
  testGroup: {},
};

function initializeState() {
  return Object.assign({}, initialState);
}

export default function auth(state = initializeState(), action = {}) {
  switch (action.type) {

    case CHECK_AUTH:
      return {
        ...state,
        checkingAuth: true,
        isAuthChecked: false,
      };
    case CHECK_AUTH_SUCCESS:
      const user = action.response;

      return {
        ...state,
        checkingAuth: false,
        isAuthChecked: true,
        isLoggedIn: true,
        user: {
          ...state.user,
          ...user,
        },
      }
    case CHECK_AUTH_FAIL:
      return {
        ...state,
        checkingAuth: false,
        isAuthChecked: true,
        isLoggedIn: false,
        isStorageCookieChecked: true,
      }
    case CHECK_AUTH_ABORTED:
      return {
        ...state,
        checkingAuth: false,
        isAuthChecked: false,
        isLoggedIn: false,
        isStorageCookieChecked: false,
      }

    case REQUEST_STORAGE_COOKIE:
      return {
        ...state,
        isStorageCookieRequesting: true,
        isStorageCookieChecked: false,
      };

    case REQUEST_STORAGE_COOKIE_SUCCESS:
      return {
        ...state,
        isStorageCookieOk: true,
        isStorageCookieRequesting: false,
        isStorageCookieChecked: true,
      };

    case REQUEST_STORAGE_COOKIE_FAIL:
      return {
        ...state,
        isStorageCookieOk: false,
        isStorageCookieRequesting: false,
        isStorageCookieChecked: true,
      };

    case SET_REFERRAL:
      return {
        ...state,
        referralUid: action.additional.uid,
        referralUidSetting: true,
        referralUidSet: false,
      }
    case SET_REFERRAL_SUCCESS:
      if (action.additional.uid !== state.referralUid) {
        return state;
      }

      return {
        ...state,
        referralUidSetting: false,
        referralUidSet: true,
      }
    case SET_REFERRAL_FAIL:
      if (action.additional.uid !== state.referralUid) {
        return state;
      }

      return {
        ...state,
        referralUidSetting: false,
        referralUidSet: false,
      }
    case SET_CLICK_ID:
      return {
        ...state,
        clickId: action.additional.clickId,
        clickIdReferral: action.additional.referral,
        clickIdEnot: action.additional.enot,
        clickIdSetting: true,
        clickIdSet: false,
      }
    case SET_CLICK_ID_SUCCESS:
      if (
        action.additional.clickId !== state.clickId ||
        action.additional.referral !== state.clickIdReferral ||
        action.additional.enot !== state.clickIdEnot
      ) {
        return state;
      }

      return {
        ...state,
        clickIdSetting: false,
        clickIdSet: true,
      }
    case SET_CLICK_ID_FAIL:
      if (action.additional.clickId !== state.clickId || action.additional.referral !== state.clickIdReferral) {
        return state;
      }

      return {
        ...state,
        clickIdSetting: false,
        clickIdSet: false,
      }
    case SET_NEED_SADUKA_AUTH_UPDATE:
      return {
        ...state,
        needSadukaAuthUpdate: (new Date()).valueOf(),
      }

    case SET_API_HEADERS:
      return {
        ...state,
        apiHeaders: action.apiHeaders
      }

    case GET_LAYOUT_DATA_SUCCESS:
      const redirectUrl = action.response.redirect_url || undefined;
      return {
        ...state,
        user: {
          ...state.user,
          id: action.response.user.id,
          email: action.response.user.email,
          name: action.response.user.name,
          isBanned: action.response.user.isBanned,
          isBlogger: action.response.user.isBlogger,
          permissions: action.response.data.permissions,
          headerBar: action.response.data.header.bar,
          projects: action.response.data.projects,
        },
        creditsUrl: action.response.data.credits.url,
        redirectUrl,
        testGroup: action.response.test_group,
      }

    case LOAD_USER_BALANCE:
      return {
        ...state,
        isLoadingUserBalance: true,
        isLoadedUserBalance: false,
      };
    case LOAD_USER_BALANCE_SUCCESS:
      return {
        ...state,
        balance: {
          ...state.balance,
          approved: action.response.approved,
          available: action.response.available,
          currency: action.response.currency,
          hold_total: action.response.hold_total,
          hold_advertiser: action.response.hold_advertiser,
          hold_cityads: action.response.hold_cityads,
          hold_duration: action.response.hold_duration,
          on_output: action.response.on_output,
          credit_available: action.response.credit_available,
          credit_issued: action.response.credit_issued,
          credit_limit: action.response.credit_limit,
          promo: action.response.promo,
        },
        isLoadingUserBalance: false,
        isLoadedUserBalance: true,
      };
    case LOAD_USER_BALANCE_FAIL:
      return {
        ...state,
        isLoadingUserBalance: false,
        isLoadedUserBalance: false,
      };


    default:
      return state;
  }
}
